<template>
  <div v-if="nonFoodTemplates && pageSide" class="grid grid-cols-3 gap-1 bg-primary shrink">
    <div v-for="(template,idx) in nonFoodTemplates.filter((template) => template.name.toLowerCase().indexOf( pageSide == 'right' ? 'rechts' : 'links') > 0 )" class="items-center flex flex-col">
      <div class="flex-shrink border-4 border-transparent hover:border-trader-blue cursor-pointer relative" @click="() => {onChangePageTemplate(template)}">
        <div class="z-20 absolute top-0 left-0 right-0 bottom-0"></div>
        <object :ref="idx" type="image/svg+xml" class="w-[80px]" :style="objectStyles?.[idx]"
                :data="'/api/v3/preview/grid/'+ template.pageTemplateId + '?callback=' + createCallback(idx) ">
          <param name="type" value="image/svg+xml">
        </object>
      </div>
      <span>{{template.name}}</span>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";

export default {
  data() {
    return {
      objectStyles: [],
    }
  },
  computed: {
    ...mapState('pageTemplates', ['nonFoodTemplates']),
    ...mapState('page', ['pageId']),
    ...mapGetters('page', ['pageSide']),
  },
  methods: {
    ...mapActions('pageTemplates', ['fetchNonFoodTemplates']),
    ...mapActions('page', ['changePageTemplate']),
    createCallback(index) {
      window.crossApi.callbacks['non_food_page_template_'+index] = (w, h) => {
        this.objectStyles[index] = {
          width: w + 'px',
          height: h + 'px',
        };
      };
      return 'non_food_page_template_' + index;
    },
    onChangePageTemplate(template) {
      eventBus.openConfirm({
        title: 'Seitenvorlage ändern',
        message: 'Durch das Ändern der Seitenvorlage könnten Inhalte auf der Seite verloren gehen. Möchten Sie fortfahren?',
        onAccept: async () => {

          console.log('change page template: %o', {
            pageId: this.pageId,
            pageTemplateId: template.pageTemplateId,
          });

          await this.changePageTemplate({
            pageId: this.pageId,
            pageTemplateId: template.pageTemplateId,
          });

          SignalBus.emit("reload-project-page", null)
          //this.$store.dispatch('page/changePageTemplate', template);
        },
      });
      
    },
  },
  mounted() {
    this.fetchNonFoodTemplates();
  },
}
</script>

